import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import VisitUsHero from "./visit-us-hero";
import InformationArticles from "./InformationArticles";
import ArticleTabs from "./ArticleTabs";
import PrivateFunctions from "./PrivateFunctions";
import BookingForm from "./BookingForm";
import Overlay from "../../components/Overlay";
import Newsletter from "../../components/_common/Newsletter";
import BookCta from "../../components/_common/BookCta";
import MetaDetail from "../../components/_common/MetaDetail";

import { buildContentAction } from "../../services/content/actions";
import tracking from "../../utils/tracking";
import "./visitus.scss";

const overlayId = "Private Booking Form";
class VisitUsPage extends Component {
	moduleNames = [
		{ name: "Opening times card", title: "Hero" },
		{ name: "Intro module", title: "Intro" },
		{ name: "Newsletter sign up module", title: "Newsletter" },
		{
			name: "Image / Subtitle / Description component",
			title: "Articles"
		},
		{ name: "Concertina", title: "Info" },
		{ name: "CTA", title: "InfoCta" },
		{ name: "Private functions overview", title: "PrivateFunctions" },
		{ name: "Image carousel", title: "ImageCarousel" },
		{ name: "Book Module", title: "Book" }
	];

	componentDidMount() {
		tracking.pageView("/visit-the-taproom");

		if (!this.props.data.fetchedData) {
			this.props.fetchData(
				{ name: "visitUsPage", modules: this.moduleNames, transform: true },
				true,
				"VISIT THE TAPROOM"
			);
		} else if (!this.props.data.built && this.props.data.data) {
			this.props.buildContentAction(this.props.data.data, {
				name: "visitUsPage",
				modules: this.moduleNames,
				transform: true
			});
		} else {
			console.log("VisitUsPage - data fetched");
		}
	}

	render() {
		if (!this.props.data || !this.props.data.contents) {
			return;
		}

		const { componentData } = this.props;
		const { contents } = this.props.data;
		const meta = {
			title: 'The Taproom',
			description: 'Sample exclusive beers made by our experimental brewers',
			canonical: window.location.href
		}


		return (
			<div className="VisitUsPage">
				<MetaDetail meta={meta} />
				<VisitUsHero
					content={contents.Hero[0]}
					introContent={contents.Intro[0]}
				/>
				<InformationArticles items={contents.Articles} />
				<ArticleTabs
					content={contents.Info}
					infoCta={contents.InfoCta[0]}
					overlayId={overlayId}
				/>
				<PrivateFunctions
					content={contents.PrivateFunctions[0]}
					imageCarousel={contents.ImageCarousel}
					overlayId={overlayId}
				/>
				<Overlay
					id={overlayId}
					routeProps={this.props.routeProps}
					hideClose={true}
				>
					<BookingForm
						data={componentData.privateBookingForm}
						fetchData={this.props.fetchData}
						routeProps={this.props.routeProps}
						id={overlayId}
					/>
				</Overlay>
				<Newsletter
					content={contents.Newsletter[0]}
					formData={componentData.signUpForm}
					fetchData={this.props.fetchData}
					routeProps={this.props.routeProps}
				/>
				<BookCta
					link={contents.Book[0]["CTA LINK"].value}
					label={contents.Book[0]["CTA COPY"].value}
					path={contents.Book[0]["CTA LINK"].value}
					routeProps={this.props.routeProps}
				/>
			</div>
		);
	}
}

export default connect(
	() => ({}),
	{ buildContentAction }
)(VisitUsPage);



// WEBPACK FOOTER //
// ./src/pages/visitus/index.js